import { render, staticRenderFns } from "./UpdateDescriptionModal.vue?vue&type=template&id=0e036492&scoped=true&"
import script from "./UpdateDescriptionModal.vue?vue&type=script&lang=ts&"
export * from "./UpdateDescriptionModal.vue?vue&type=script&lang=ts&"
import style0 from "./UpdateDescriptionModal.vue?vue&type=style&index=0&id=0e036492&lang=scss&scoped=true&"
import style1 from "./UpdateDescriptionModal.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e036492",
  null
  
)

export default component.exports